import React, { useState } from 'react'
import { Modal, Button, Form, Upload, message } from 'antd'
import { InboxOutlined } from '@ant-design/icons'

const { Dragger } = Upload

const FinalizeSaqueModal = (props) => {
    const { 
        visible, 
        handleCancel, 
        handleFinalize, 
        saqueId,
        isSubmit 
    } = props
    
    const [form] = Form.useForm()
    const [fileList, setFileList] = useState([])
    
    const onFinish = () => {
        if (fileList.length === 0) {
            message.error('Por favor, faça upload do comprovante')
            return
        }
        
        // Get the file from the fileList
        const file = fileList[0].originFileObj
        
        // Create form data
        handleFinalize(saqueId, file)
    }
    
    // Clear form when modal closes
    const handleModalCancel = () => {
        form.resetFields()
        setFileList([])
        handleCancel()
    }
    
    // Handle file upload
    const handleUploadChange = (info) => {
        let fileList = [...info.fileList]
        
        // Limit to 1 file
        fileList = fileList.slice(-1)
        
        // Update fileList
        setFileList(fileList)
    }
    
    // Upload props
    const uploadProps = {
        name: 'file',
        multiple: false,
        fileList,
        beforeUpload: (file) => {
            // Check file type
            const isValidType = file.type === 'application/pdf' || 
                               file.type.startsWith('image/');
            
            if (!isValidType) {
                message.error('Você só pode fazer upload de arquivos PDF ou imagens!');
                return Upload.LIST_IGNORE;
            }
            
            // Check file size (10MB max)
            const isLessThan10M = file.size / 1024 / 1024 < 10;
            if (!isLessThan10M) {
                message.error('O arquivo deve ser menor que 10MB!');
                return Upload.LIST_IGNORE;
            }
            
            return false; // Prevent auto upload
        },
        onChange: handleUploadChange,
    }
    
    return (
        <Modal
            title="Finalizar Saque"
            open={visible}
            onCancel={handleModalCancel}
            footer={null}
        >
            <Form 
                form={form}
                layout="vertical"
                onFinish={onFinish}
            >
                <Form.Item
                    label="Comprovante de Transferência"
                    name="comprovante"
                    rules={[
                        { 
                            required: true, 
                            message: 'Por favor, faça upload do comprovante' 
                        }
                    ]}
                >
                    <Dragger {...uploadProps}>
                        <p className="ant-upload-drag-icon">
                            <InboxOutlined />
                        </p>
                        <p className="ant-upload-text">
                            Clique ou arraste um arquivo para esta área para fazer upload
                        </p>
                        <p className="ant-upload-hint">
                            Suporta apenas um único arquivo. PDF ou imagens (JPG, PNG)
                        </p>
                    </Dragger>
                </Form.Item>
                
                <Form.Item style={{ marginBottom: 0, textAlign: 'right' }}>
                    <Button 
                        style={{ marginRight: 8 }} 
                        onClick={handleModalCancel}
                    >
                        Cancelar
                    </Button>
                    <Button 
                        type="primary" 
                        htmlType="submit"
                        loading={isSubmit}
                    >
                        Finalizar
                    </Button>
                </Form.Item>
            </Form>
        </Modal>
    )
}

export default FinalizeSaqueModal 